export class AbstractFetcher {
    constructor() {}

    fetch(func, params, delay = 0): Promise<any> {
        throw 'not implemented';
    }
}
